if(document.getElementById('center-stats')) {
  const observer = new IntersectionObserver(counter, { threshold: .5 })
  observer.observe(document.getElementById('center-stats'))
}

function counter() {
  const counters = document.querySelectorAll(".counter");
  const duration = 2000; 

  counters.forEach((counter) => {
    counter.innerText = "0";
  });

  const startTime = performance.now();

  function updateCounters(currentTime) {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);

    counters.forEach((counter) => {
      const target = +counter.getAttribute("data-target");
      const value = Math.floor(progress * target);

      counter.innerText = value;
    });

    if (progress < 1) {
      requestAnimationFrame(updateCounters);
    } else {
      counters.forEach((counter) => {
        counter.innerText = counter.getAttribute("data-target");
      });
    }
  };

  requestAnimationFrame(updateCounters);
}